export class CurrentPrevious {
  current!: number;
  previous!: number;

  get percentChange(): number {
    return Math.round(((100 * (this.current - this.previous)) / this.previous));
  }
}
